import { ROUTES } from "@nf/constants";
import React from "react";

import { LinkWithLocale } from "../../../components";

import SearchIcon from "../../../resources/icons/search.svg";

import styles from "./SearchInput.module.scss";

export type SearchButtonProps = {
  onClick?: () => void;
};

export const SearchButton = ({ onClick }: SearchButtonProps) => {
  if (onClick) {
    return (
      <button onClick={onClick}>
        <SearchIcon className={styles.searchIcon} />
      </button>
    );
  }

  return (
    <LinkWithLocale href={ROUTES.SEARCH_SCREEN}>
      <a>
        <SearchIcon className={styles.searchIcon} />
      </a>
    </LinkWithLocale>
  );
};

export default SearchButton;
